//#region src/schema/localization/locales/ar.ts
var e = {
	schema: {
		variants: "المتغيرات",
		discriminatorValue: "قيمة المميز",
		noAllowedValues: "لا توجد قيم تستوفي قيد التعداد هذا.",
		example: "مثال",
		examples: "أمثلة",
		default: "الافتراضي",
		schema: "المخطط",
		emptyObject: "كائن فارغ",
		showAdditionalProperties: "إظهار الخصائص الإضافية",
		showOneMoreProperty: "إظهار خاصية إضافية واحدة",
		showMoreProperties: "إظهار المزيد من الخصائص ({count})",
		forName: "لـ {name}",
		showSchemaDetails: "إظهار تفاصيل المخطط",
		oneOf: "واحد من",
		anyOf: "أي من",
		allOf: "كل من",
		not: "ليس",
		unknownType: "نوع غير معروف",
		propertyCount: "الخصائص: {count}",
		headerCount: "الترويسات: {count}",
		recursiveReference: "مرجع تكراري إلى {name}",
		recursive: "تكراري",
		additionalProperties: "خصائص إضافية",
		const: "ثابت",
		deprecated: "مهمل",
		discriminator: "المميّز",
		enum: "تعداد",
		format: "التنسيق",
		greaterThan: "أكبر من",
		keys: "المفاتيح",
		lessThan: "أقل من",
		max: "الحد الأقصى",
		min: "الحد الأدنى",
		maxLength: "أقصى طول",
		minLength: "أدنى طول",
		multipleOf: "مضاعف لـ",
		nullable: "يقبل null",
		propertyNames: "أسماء الخصائص",
		pattern: "النمط",
		copyPattern: "نسخ النمط",
		readOnly: "قراءة فقط",
		required: "مطلوب",
		hideValues: "إخفاء القيم",
		showAllValues: "عرض كل القيم",
		type: "النوع",
		unique: "فريد",
		values: "القيم",
		writeOnly: "كتابة فقط",
		typeInteger: "أعداد صحيحة.",
		formatInt32: "أعداد صحيحة بإشارة بطول 32 بت (نوع الأعداد الصحيحة الشائع).",
		formatInt64: "أعداد صحيحة بإشارة بطول 64 بت (النوع long).",
		formatDate: "تدوين full-date وفق RFC 3339، القسم 5.6، مثلًا 2017-07-21",
		formatDateTime: "تدوين date-time وفق RFC 3339، القسم 5.6، مثلًا 2017-07-21T17:32:28Z",
		formatPassword: "تلميح للواجهات بإخفاء الإدخال",
		formatBase64: "أحرف بترميز base64، مثلًا U3dhZ2dlciByb2Nrcw==",
		formatBinary: "بيانات ثنائية لوصف الملفات"
	},
	common: {
		copyDefault: "نسخ القيمة الافتراضية",
		copyExample: "نسخ القيمة النموذجية"
	},
	actions: { copyLinkTo: "نسخ الرابط إلى {name}" }
};
//#endregion
export { e as ar };

//# sourceMappingURL=ar.js.map